module.exports = __webpack_public_path__ + "img/skillsB-4.ba96e4dc.png";